module.exports = __webpack_public_path__ + "static/media/sidebar-6.08efb632.jpg";